/**
 * Script para habilitar o botão de comparação na página inicial
 * Faz com que o botão de comparação na home funcione da mesma forma que nas páginas de coleção
 */

// Função para carregar recursos necessários para o modal de comparação
function loadCompareResources() {
  // Verifica se os recursos já foram carregados
  if (window.compareResourcesLoaded) return Promise.resolve();
  
  // Obtém os recursos do elemento JSON
  const resourcesElement = document.getElementById('compare-resources');
  if (!resourcesElement) return Promise.resolve();
  
  try {
    const resources = JSON.parse(resourcesElement.textContent);
    const promises = [];
    
    // Carrega cada recurso
    resources.forEach(resource => {
      if (resource.type === 'js') {
        // Verifica se o script já foi carregado
        const existingScript = document.querySelector(`script[src="${resource.path}"]`);
        if (!existingScript) {
          const promise = new Promise((resolve, reject) => {
            const script = document.createElement('script');
            script.src = resource.path;
            script.onload = resolve;
            script.onerror = reject;
            document.head.appendChild(script);
          });
          promises.push(promise);
        }
      } else if (resource.type === 'css') {
        // Verifica se o CSS já foi carregado
        const existingLink = document.querySelector(`link[href="${resource.path}"]`);
        if (!existingLink) {
          const link = document.createElement('link');
          link.rel = 'stylesheet';
          link.href = resource.path;
          document.head.appendChild(link);
        }
      }
    });
    
    return Promise.all(promises).then(() => {
      window.compareResourcesLoaded = true;
    });
  } catch (e) {
    console.error('Erro ao carregar recursos do compare:', e);
    return Promise.resolve();
  }
}

document.addEventListener('DOMContentLoaded', function() {
  // Função para inicializar os botões de comparação
  function initCompareButtons() {
    // Seleciona todos os botões de comparação na página inicial
    const compareButtons = document.querySelectorAll('.btn.btn--primary.js-trigger-compare.w-full');
    const compareModal = document.querySelector('.js-compare-modal');
    
    if (compareButtons.length > 0 && compareModal) {
      // Adiciona evento de clique para cada botão encontrado
      compareButtons.forEach(button => {
        // Remove eventos anteriores para evitar duplicação
        button.removeEventListener('click', handleCompareButtonClick);
        // Adiciona o novo evento de clique
        button.addEventListener('click', handleCompareButtonClick);
      });
      
      console.log('Home compare trigger initialized');
    }
  }
  
  // Função para lidar com o clique no botão de comparação
  function handleCompareButtonClick(event) {
    event.preventDefault();
    
    // Carrega os recursos necessários antes de abrir o modal
    loadCompareResources().then(() => {
      // Garante que o elemento details-modal esteja definido
      if (!customElements.get('details-modal')) {
        console.error('details-modal não está definido. Tentando carregar...');
        return;
      }
      
      const compareModal = document.querySelector('.js-compare-modal');
      
      if (compareModal) {
        // Verifica se o modal está oculto e remove a classe hidden
        const modalDetails = compareModal.querySelector('.details-modal');
        if (modalDetails && modalDetails.classList.contains('hidden')) {
          modalDetails.classList.remove('hidden');
        }
        
        // Dispara o evento para abrir o modal de comparação
        compareModal.dispatchEvent(new CustomEvent('on:product-compare-modal:open', { bubbles: true }));
        
        // Garante que o modal seja exibido
        setTimeout(() => {
          const modal = compareModal.querySelector('.modal');
          if (modal) {
            modal.style.display = 'flex';
            
            // Garante que o modal esteja visível
            if (window.getComputedStyle(modal).display === 'none') {
              modal.style.display = 'flex';
              modal.style.opacity = '1';
              modal.style.visibility = 'visible';
            }
          }
        }, 100);
      }
    }).catch(error => {
      console.error('Erro ao inicializar o modal de comparação:', error);
    });
  }
  
  // Inicializa os botões de comparação após carregar os recursos
  loadCompareResources().then(() => {
    initCompareButtons();
    
    // Reinicializa os botões quando o DOM for modificado (por exemplo, após carregamento de AJAX)
    const observer = new MutationObserver(function(mutations) {
      initCompareButtons();
    });
    
    // Observa mudanças no corpo do documento
    observer.observe(document.body, { childList: true, subtree: true });
  }).catch(error => {
    console.error('Erro ao carregar recursos para comparação:', error);
  });
});
